<template>
  <div class="open-fund-header row justify-between">
    <combined-logo/>
    <shopping-cart-icon v-if="showShoppingCart" :indicator="indicator" :blink="blink" @click="shoppingCartClicked"/>
  </div>
</template>

<script>
import Segment from '@/Segment';
import ShoppingCartIcon from '@/components/styled/ShoppingCartIcon';
import CombinedLogo from '@/components/meitav-dash/CombinedLogo';

export default {
  name: 'OpenFundHeader',
  components: { CombinedLogo, ShoppingCartIcon },
  props: {
    indicator: Boolean,
    showShoppingCart: Boolean,
    blink: Boolean,
  },
  methods: {
    shoppingCartClicked() {
      Segment.trackUserInteraction('Saving_ShoppingCartClicked');
    },
  },
};
</script>

<style scoped lang="scss">

.open-fund-header {
  margin-bottom: 42px;
}

</style>
